'use client'

import { memo, useEffect, useMemo, useState } from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'
import { processHtmlLinks } from '@/_utils/link.utils'

export type EditorJsBenefitParagraphHtmlProps = {
	html: string
	className?: string
}

/**
 * Benefit / EditorJS paragraph: same sanitization as list items (`sanitizeAndProcessHtml(..., false)`),
 * then {@link processHtmlLinks} after mount so internal vs external `target`/`rel` matches {@link processLink}.
 */
export const EditorJsBenefitParagraphHtml = memo(function EditorJsBenefitParagraphHtml({
	html,
	className
}: EditorJsBenefitParagraphHtmlProps) {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	const safeHtml = useMemo(() => {
		const sanitized = sanitizeAndProcessHtml(html ?? '', false)
		if (!mounted || typeof window === 'undefined') {
			return sanitized
		}
		return processHtmlLinks(sanitized)
	}, [html, mounted])

	return <p className={className} dangerouslySetInnerHTML={{ __html: safeHtml }} />
})

EditorJsBenefitParagraphHtml.displayName = 'EditorJsBenefitParagraphHtml'
